export const environment = {
  production: true,
  apiUrl: 'https://i-sms.pro/api',
  stripePublicKey: 'pk_live_JP63RV9jwF4yELKLA0ATkN3G',
};
